import UserList from 'components/users/UserList';
import CreateButton from 'components/ui/buttons/CreateButton';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';

const MembersTab = () => {
  return (
    <>
      <UserList />
      <CreateButton to="/admin/members/invite/new" />
    </>
  );
};

export default withAuthorizer(MembersTab, [Resources.USER_MANAGER]);
